<template>
  <router-link-modified :to="{name: 'home'}"
                        :class="isVertical ? '_vertical' : ''"
                        class="main-logo">
    <picture class="main-logo__img-wrap">
      <source v-if="isVertical && logoVWebp"
              :srcset="logoVWebp"
              type="image/webp">
      <source v-else-if="!isVertical && logoHWebp"
              :srcset="logoHWebp"
              type="image/webp">
      <img v-if="isVertical"
           class="main-logo__img main-logo__img--vertical"
           width="200"
           height="50"
           :src="logoV"
           :alt="createAltMixin('Logo')"
           :title="createTitleMixin('Logo')">
      <img v-else
           class="main-logo__img main-logo__img--horizontal"
           width="200"
           height="50"
           :src="logoH"
           :alt="createAltMixin('Logo')"
           :title="createTitleMixin('Logo')">
    </picture>

  </router-link-modified>
</template>

<script>
  export default {
    name: "MainLogo",
    props: {
      isVertical: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    computed: {
      logoV() {
        return globalConfigs && globalConfigs.header.logo_vertical || 'https://api.jobian.com/storage/settings/January2020/xNiHAQevmCKpUZijZ3V0.png'
      },
      logoVWebp() {
        return globalConfigs && globalConfigs.header.logo_vertical_webp
      },
      logoH() {
        return globalConfigs && globalConfigs.header.logo_horizontal || 'https://api.jobian.com/storage/settings/January2020/rvSqR1keRQQmC4S8UVCt.png'
      },
      logoHWebp() {
        return globalConfigs && globalConfigs.header.logo_horizontal_webp
      }
    }
  }
</script>

<style lang="less">

</style>
